import React, { useState } from "react"
import { AnimatePresence, motion } from "framer-motion"
import { RotateCcw, X } from "lucide-react"
import renderFilters from "./filterRenderers"
import { useTranslation } from "react-i18next"

const MobileModal = ({ filterConfig = [], onReset }) => {
  const { t } = useTranslation()
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <button
        onClick={() => setIsOpen(true)}
        className="xl:hidden fixed bottom-4 right-4 bg-app-base-strong text-white px-6 py-3 rounded-full shadow-lg z-50 hover:bg-app-base transition-colors font-medium"
      >
        {t("admin.filters")}
      </button>

      <AnimatePresence>
        {isOpen && (
          <>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => setIsOpen(false)}
              className="xl:hidden fixed inset-0 bg-black/50 z-50"
            />

            <motion.div
              initial={{ y: "100%" }}
              animate={{ y: 0 }}
              exit={{ y: "100%" }}
              transition={{ type: "spring", damping: 30, stiffness: 300 }}
              className="xl:hidden fixed bottom-0 left-0 right-0 bg-white z-50 rounded-t-2xl max-h-[90vh] flex flex-col"
            >
              <div className="sticky top-0 bg-white border-b border-gray-200 px-4 py-3 flex justify-end rounded-t-2xl">
                <button
                  onClick={() => setIsOpen(false)}
                  className="p-2 hover:bg-gray-100 rounded-full transition-colors"
                >
                  <X className="w-6 h-6" />
                </button>
              </div>

              <div className="flex-1 overflow-y-auto px-4 py-4">
                {renderFilters(filterConfig, t)}
              </div>

              <div className="sticky bottom-0 bg-white border-t border-gray-200 p-4 flex gap-3">
                <button
                  onClick={() => {
                    onReset?.()
                    setIsOpen(false)
                  }}
                  className="flex-1 py-3 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors font-medium flex items-center justify-center gap-2"
                >
                  <RotateCcw size={18} />
                  <span>{t("admin.reset")}</span>
                </button>
                <button
                  onClick={() => setIsOpen(false)}
                  className="flex-1 py-3 bg-app-base-strong text-white rounded-lg hover:bg-app-base transition-colors font-medium"
                >
                  {t("admin.apply")}
                </button>
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </>
  )
}

export default MobileModal
